import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["refreshButton"])
  },
  watch: {
    refreshButton: function() {
      this.fetchItems();
    }
  }
};
